export default "__VITE_ASSET__21e41db9__"